export default {
  af: {
    key: 'af',
    locale: 'af_ZA',
    name: 'Afrikaans',
    localizedName: 'Afrikaans'
  },
  am: {
    key: 'am',
    locale: 'am_ET',
    name: 'አማርኛ',
    localizedName: 'Amharic'
  },
  ar: {
    key: 'ar',
    locale: 'ar_SA',
    name: 'العربية (المملكة العربية السعودية)',
    direction: 'rtl',
    localizedName: 'Arabic (Saudi Arabia)'
  },
  arAE: {
    key: 'arAE',
    locale: 'ar_AE',
    name: 'العربية (الإمارات العربية المتحدة)',
    direction: 'rtl',
    localizedName: 'Arabic (United Arab Emirates)'
  },
  arEG: {
    key: 'arEG',
    locale: 'ar_EG',
    name: 'العربية (مصر)',
    direction: 'rtl',
    localizedName: 'Arabic (Egypt)'
  },
  bg: {
    key: 'bg',
    locale: 'bg_BG',
    name: 'български',
    localizedName: 'Bulgarian'
  },
  bn: {
    key: 'bn',
    locale: 'bn_BD',
    name: 'বাংলা',
    localizedName: 'Bengali'
  },
  bs: {
    key: 'bs',
    locale: 'bs_BA',
    name: 'Bosanski',
    localizedName: 'Bosnian'
  },
  cs: {
    key: 'cs',
    locale: 'cs_CZ',
    name: 'Čeština',
    localizedName: 'Czech'
  },
  cy: {
    key: 'cy',
    locale: 'cy_GB',
    name: 'Cymraeg',
    localizedName: 'Welsh'
  },
  da: {
    key: 'da',
    locale: 'da_DK',
    name: 'Dansk',
    localizedName: 'Danish'
  },
  de: {
    key: 'de',
    locale: 'de_DE',
    name: 'Deutsch',
    localizedName: 'German'
  },
  el: {
    key: 'el',
    locale: 'el_GR',
    name: 'Ελληνικά',
    localizedName: 'Greek'
  },
  en: {
    key: 'en',
    locale: 'en_US',
    name: 'English',
    localizedName: 'English'
  },
  enGB: {
    key: 'enGB',
    locale: 'en_GB',
    name: 'English (United Kingdom)',
    localizedName: 'English (United Kingdom)'
  },
  es: {
    key: 'es',
    locale: 'es_ES',
    name: 'Español (España)',
    localizedName: 'Spanish (Spain)'
  },
  esMX: {
    key: 'esMX',
    locale: 'es_MX',
    name: 'Español (México)',
    localizedName: 'Spanish (Mexico)'
  },
  et: {
    key: 'et',
    locale: 'et_EE',
    name: 'Eesti keel',
    localizedName: 'Estonian'
  },
  fi: {
    key: 'fi',
    locale: 'fi_FI',
    name: 'Suomi',
    localizedName: 'Finnish'
  },
  fr: {
    key: 'fr',
    locale: 'fr_FR',
    name: 'Français (France)',
    localizedName: 'French (France)'
  },
  frCA: {
    key: 'frCA',
    locale: 'fr_CA',
    name: 'Français (Canada)',
    localizedName: 'French (Canada)'
  },
  he: {
    key: 'he',
    locale: 'he_IL',
    name: 'עִבְרִית',
    direction: 'rtl',
    localizedName: 'Hebrew'
  },
  hi: {
    key: 'hi',
    locale: 'hi_IN',
    name: 'िन्दी',
    localizedName: 'Hindi'
  },
  hk: {
    key: 'hk',
    locale: 'zh_HK',
    name: '繁體中文',
    localizedName: 'Chinese traditional'
  },
  ht: {
    key: 'ht',
    locale: 'ht_HT',
    name: 'kreyòl ayisyen',
    localizedName: 'Haitian Creole'
  },
  hr: {
    key: 'hr',
    locale: 'hr_HR',
    name: 'Hrvatski',
    localizedName: 'Croatian'
  },
  hu: {
    key: 'hu',
    locale: 'hu_HU',
    name: 'Magyar',
    localizedName: 'Hungarian'
  },
  id: {
    key: 'id',
    locale: 'id_ID',
    name: 'Bahasa Indonesia',
    localizedName: 'Indonesian'
  },
  is: {
    key: 'is',
    locale: 'is_IS',
    name: 'Íslenska',
    localizedName: 'Icelandic'
  },
  it: {
    key: 'it',
    locale: 'it_IT',
    name: 'Italiano',
    localizedName: 'Italian'
  },
  ja: {
    key: 'ja',
    locale: 'ja_JP',
    name: '日本語',
    localizedName: 'Japanese'
  },
  kl: {
    key: 'kl',
    locale: 'kl_GL',
    name: 'Kalaallisut',
    localizedName: 'Greenlandic'
  },
  km: {
    key: 'km',
    locale: 'km_KH',
    name: 'ខ្មែរ',
    localizedName: 'Khmer'
  },
  ko: {
    key: 'ko',
    locale: 'ko_KR',
    name: '한국어',
    localizedName: 'Korean'
  },
  lo: {
    key: 'lo',
    locale: 'lo_LA',
    name: 'ລາວ',
    localizedName: 'Lao'
  },
  lt: {
    key: 'lt',
    locale: 'lt_LT',
    name: 'Lietuvių',
    localizedName: 'Lithuanian'
  },
  lv: {
    key: 'lv',
    locale: 'lv_LV',
    name: 'Latviešu',
    localizedName: 'Latvian'
  },
  mg: {
    key: 'mg',
    locale: 'mg_MG',
    name: 'Malagasy',
    localizedName: 'Malagasy'
  },
  mk: {
    key: 'mk',
    locale: 'mk_MK',
    name: 'Македонски',
    localizedName: 'Macedonian'
  },
  mh: {
    key: 'mh',
    locale: 'mh_MH',
    name: 'Kajin M̧ajeļ',
    localizedName: 'Marshallese'
  },
  mi: {
    key: 'mi',
    locale: 'mi_NZ',
    name: 'Māori',
    localizedName: 'Māori'
  },
  mn: {
    key: 'mn',
    locale: 'mn_MN',
    name: 'монгол',
    localizedName: 'Mongolian'
  },
  mr: {
    key: 'mr',
    locale: 'mr_IN',
    name: 'मराठी',
    localizedName: 'Marathi'
  },
  ms: {
    key: 'ms',
    locale: 'ms_MY',
    name: 'Bahasa Melayu',
    localizedName: 'Malay'
  },
  my: {
    key: 'my',
    locale: 'my_MM',
    name: 'Burmese',
    localizedName: 'Burmese'
  },
  ne: {
    key: 'ne',
    locale: 'ne_NP',
    name: 'नेपाली',
    localizedName: 'Nepali'
  },
  nl: {
    key: 'nl',
    locale: 'nl_NL',
    name: 'Nederlands',
    localizedName: 'Dutch'
  },
  nlBE: {
    key: 'nlBE',
    locale: 'nl_BE',
    name: 'Vlaemsch',
    localizedName: 'Flemish'
  },
  no: {
    key: 'no',
    locale: 'no_NO',
    name: 'Norsk',
    localizedName: 'Norwegian'
  },
  pl: {
    key: 'pl',
    locale: 'pl_PL',
    name: 'Polski',
    localizedName: 'Polish'
  },
  pt: {
    key: 'pt',
    locale: 'pt_PT',
    name: 'Português (Portugal)',
    localizedName: 'Portuguese (Portugal)'
  },
  ptBR: {
    key: 'ptBR',
    locale: 'pt_BR',
    name: 'Português (Brasil)',
    localizedName: 'Portuguese (Brazil)'
  },
  ro: {
    key: 'ro',
    locale: 'ro_RO',
    name: 'Română',
    localizedName: 'Romanian'
  },
  ru: {
    key: 'ru',
    locale: 'ru_RU',
    name: 'Русский',
    localizedName: 'Russian'
  },
  si: {
    key: 'si',
    locale: 'si_LK',
    name: 'සිංහල',
    localizedName: 'Sinhala'
  },
  sk: {
    key: 'sk',
    locale: 'sk_SK',
    name: 'Slovenský',
    localizedName: 'Slovak'
  },
  sl: {
    key: 'sl',
    locale: 'sl_SI',
    name: 'Slovenščina',
    localizedName: 'Slovenian'
  },
  sq: {
    key: 'sq',
    locale: 'sq_AL',
    name: 'Shqip',
    localizedName: 'Albanian'
  },
  sr: {
    key: 'sr',
    locale: 'sr_RS',
    name: 'Српски',
    localizedName: 'Serbian'
  },
  so: {
    key: 'so',
    locale: 'so_SO',
    name: 'Af-Soomaali',
    localizedName: 'Somali'
  },
  sv: {
    key: 'sv',
    locale: 'sv_SE',
    name: 'Svenska',
    localizedName: 'Swedish'
  },
  sw: {
    key: 'sw',
    locale: 'sw_TZ',
    name: 'Swahili',
    localizedName: 'Swahili'
  },
  ta: {
    key: 'ta',
    locale: 'ta_IN',
    name: 'தமிழ்',
    localizedName: 'Tamil'
  },
  tl: {
    key: 'tl',
    locale: 'tl_PH',
    name: 'Filipino',
    localizedName: 'Filipino'
  },
  th: {
    key: 'th',
    locale: 'th_TH',
    name: 'ภาษาไทย',
    localizedName: 'Thai'
  },
  tr: {
    key: 'tr',
    locale: 'tr_TR',
    name: 'Türkçe',
    localizedName: 'Turkish'
  },
  uk: {
    key: 'uk',
    locale: 'uk_UA',
    name: 'Українська',
    localizedName: 'Ukrainian'
  },
  ur: {
    key: 'ur',
    locale: 'ur_PK',
    name: 'اُردُو',
    direction: 'rtl',
    localizedName: 'Urdu'
  },
  vi: {
    key: 'vi',
    locale: 'vi_VN',
    name: 'Tiếng Việt',
    localizedName: 'Vietnamese'
  },
  zh: {
    key: 'zh',
    locale: 'zh_CN',
    name: '简体中文',
    localizedName: 'Chinese'
  },
  zu: {
    key: 'zu',
    locale: 'zu_ZA',
    name: 'isiZulu',
    localizedName: 'Zulu'
  }
};
